/*$('#trigger-overlay').on('click',function() {
  $('.overlay-door').css({
    "z-index": 10000
  });
  $('.overlay-door').animate({
    opacity: 1
  }, 300 );
});
$('.overlay-door .overlay-close').on('click',function() {
  $('.overlay-door').animate({
    opacity: 0
  }, {
    duration: 300,
    complete: function() {
      $('.overlay-door').css({"z-index": -1});
    }
  });
});*/

$('#trigger-overlay').on('click',function() {
  if ( !$('.mobnav').hasClass('open')) {
    $('.mobnav').addClass('open');
  }  
});

$('.overlay-door .mobnav-close').on('click',function() {
  if ($('.mobnav').hasClass('open')) {
    $('.mobnav').removeClass('open');
  }  
});